import React from 'react';
import { StarIcon } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María G.',
  age: 34,
  country: 'Argentina',
  role: 'Diseñadora Freelance',
  text: 'Tenía reuniones pero nunca lograba cerrar a los clientes. Desde que aplico los guiones de venta, mi tasa de cierre se duplicó. Por fin dejé de regalar mi trabajo.',
  image: '👩🏻‍💻'
}, {
  name: 'Carlos R.',
  age: 28,
  country: 'México',
  role: 'Creador de Contenido',
  text: 'Tenía miles de seguidores pero cero ventas. El sistema me enseñó a dejar de buscar likes y empezar a buscar clientes. El cambio fue brutal en solo 3 semanas.',
  image: '📱'
}, {
  name: 'Valentina M.',
  age: 31,
  country: 'Colombia',
  role: 'Coach',
  text: 'Me pasaba horas pensando qué publicar. Las 100 ideas de contenido me salvaron la vida. Ahora publico en 15 minutos y la gente me escribe por privado para contratarme.',
  image: '🎯'
}];
export function TestimonialsSection() {
  return <section className="py-20 px-4 bg-gray-100" data-id="element-191">
      <div className="max-w-6xl mx-auto" data-id="element-192">
        <h2 className="text-4xl md:text-6xl font-black text-center mb-16 uppercase" data-id="element-193">
          Gente real. <span className="text-red-600" data-id="element-194">Resultados reales.</span>
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-195">
          {TESTIMONIALS.map((testimonial, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-xl border-t-8 border-yellow-400 flex flex-col" data-id="element-196">
              <div className="flex text-yellow-400 mb-4" data-id="element-197">
                {[...Array(5)].map((_, j) => <StarIcon key={j} className="w-6 h-6 fill-current" data-id="element-198" />)}
              </div>
              <p className="text-gray-800 text-lg font-medium italic mb-6 flex-grow" data-id="element-199">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-gray-100" data-id="element-200">
                <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center text-2xl border border-gray-200" data-id="element-201">
                  {testimonial.image}
                </div>
                <div data-id="element-202">
                  <p className="font-black text-gray-900" data-id="element-203">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="text-sm text-gray-500 font-medium" data-id="element-204">
                    {testimonial.role} - {testimonial.country}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}